import { useQuery } from "@tanstack/react-query";
import client from "shared/utils/axios-config";
import { DiscountCode, DiscountCodeValidation } from "shared/types";

/* eslint-disable react-hooks/rules-of-hooks */
const getAllDiscountCodes = () => {
  return useQuery({
    queryKey: ["discount-codes"],
    queryFn: async (): Promise<DiscountCode[] | undefined> => {
      const res = await client.get(`/v1/discount-code`);
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
  });
};

// One-shot check used by the buy modal's "Terapkan" button. Not a useQuery:
// it fires on an explicit user action against the currently selected tier,
// and the answer depends on that tier + customer, so caching it would be
// misleading.
const validateDiscountCode = async (args: {
  code: string;
  packageId: number;
  customerId: string;
}): Promise<DiscountCodeValidation> => {
  const res = await client.get(`/v1/discount-code/validate`, {
    params: {
      code: args.code,
      package_id: args.packageId,
      customer_id: args.customerId,
    },
  });
  return res.data.data;
};

export { getAllDiscountCodes, validateDiscountCode };
